import script from "./DogmastersModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DogmastersModal.vue?vue&type=script&setup=true&lang=js"

import "./DogmastersModal.vue?vue&type=style&index=0&id=ebf8355e&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebf8355e"]])

export default __exports__